function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _TextInput = require("../TextInput");
var _Button = require("../Button");
var Icons = _interopRequireWildcard(require("../Icons"));
var _View = require("../View");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "onPress", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var SearchInput = exports.SearchInput = function SearchInput(_ref) {
  var label = _ref.label,
    onPress = _ref.onPress,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _value = _useState2[0],
    _setValue = _useState2[1];
  var _onChangeText = function _onChangeText(value) {
    _setValue(value);
    if (value === '') {
      onPress == null ? void 0 : onPress('');
    }
  };
  var _onPress = function _onPress() {
    onPress == null ? void 0 : onPress(_value);
  };
  var _onReset = function _onReset() {
    _setValue('');
    onPress == null ? void 0 : onPress('');
  };
  return (0, _jsxRuntime.jsxs)(_View.View, Object.assign({
    style: [styles.container, style],
    testID: "SearchInput",
    spacer: spacing.xs
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_TextInput.TextInput, {
      containerStyle: styles.inputContainer,
      placeholder: t('searchInput:label'),
      label: t('searchInput:label'),
      style: styles.input,
      value: _value,
      onChangeText: _onChangeText,
      onSubmitEditing: _onPress,
      hideLabel: true
    }), (0, _jsxRuntime.jsxs)(_View.View, {
      style: styles.actions,
      spacer: spacing.xs,
      children: [(0, _jsxRuntime.jsx)(_Button.Button, {
        hideLabel: true,
        label: t('searchInput:ariaLabel', {
          value: label
        }),
        type: _Button.ButtonType.iconOutlined,
        icon: Icons.Search,
        iconStyle: {
          width: (0, _styles2.getREM)(1.5),
          height: (0, _styles2.getREM)(1.5)
        },
        onPress: _onPress,
        state: {
          disabled: _value === ''
        }
      }), (0, _jsxRuntime.jsx)(_Button.Button, {
        hideLabel: true,
        label: t("searchInput:resetLabel"),
        type: _Button.ButtonType.iconOutlined,
        icon: Icons.Reset,
        onPress: _onReset,
        state: {
          disabled: _value === ''
        }
      })]
    })]
  }));
};